import capitalize from 'lodash.capitalize';
import type { JSX } from 'react';
import React from 'react';

import type { CampaignState as CampaignStateEnum } from '@feathr/blackbox';
import { Pill } from '@feathr/components';
import { campaignStateColorMap } from '@feathr/extender/styles/campaign';

interface IProps {
  state: string;
  name?: string;
}

function CampaignState(props: Readonly<IProps>): JSX.Element {
  const { state, name } = props;
  const theme = campaignStateColorMap.get(state as CampaignStateEnum)!;
  return (
    <Pill name={name} theme={theme} variant={'secondary'}>
      {capitalize(state)}
    </Pill>
  );
}

export default CampaignState;
